import type { UniverseId } from '@/domain/universes/universe.interface';
import type { BuildingIndicatorCode } from '../../../constants/building-indicator.constants';
import type { Period } from '../../../interfaces/Building.interface';

export interface State {
    period: Period;
    comparison: ComparisonState;
    ranking: RankingState;
}

export interface RankingState {
    axis: Axis;
}

export interface ComparisonState {
    comparisonCode: string;
    universeId: UniverseId;
    xAxis: Axis;
    yAxis: Axis;
    averageAbscissaEnabled: boolean;
    averageOrdinateEnabled: boolean;
    linearRegressionEnabled: boolean;
}

export interface Axis {
    universeId: UniverseId;
    indicatorCode: BuildingIndicatorCode;
}

export const initialState: State = {
    period: null as unknown as Period,
    comparison: {
        comparisonCode: null as unknown as string,
        universeId: null as unknown as UniverseId,
        xAxis: null as unknown as Axis,
        yAxis: null as unknown as Axis,
        averageAbscissaEnabled: false,
        averageOrdinateEnabled: false,
        linearRegressionEnabled: false
    },
    ranking: {
        axis: null as unknown as Axis
    }
};
